import React, {memo, useMemo, useState, useRef, useCallback} from "../../../../../__snowpack__/pkg/react.js";
import {Tag} from "../../../../../__snowpack__/pkg/antd.js";
import {DownOutlined, UpOutlined} from "../../../../../__snowpack__/pkg/@ant-design/icons.js";
import classNames from "../../../../../__snowpack__/pkg/classnames.js";
import {useSize} from "../../../../../__snowpack__/pkg/ahooks.js";
import {useIntl} from "../../../../../__snowpack__/pkg/react-intl.js";
import styles from "./index.module.css";
import check from "../../assets/icon/check.svg";
const {CheckableTag} = Tag;
const TagsPicker = memo((props) => {
  const {formatMessage} = useIntl();
  const {tagList = [], value = ["all"], onChange, line = 2} = props;
  const [showMore, setShowMore] = useState(false);
  const ref = useRef(null);
  const size = useSize(ref);
  const moreVisible = useMemo(() => {
    return size && size?.height > line * 28;
  }, [size]);
  const tagsData = useMemo(() => {
    return [{text: formatMessage({id: "all"}), key: "all"}, ...tagList];
  }, [tagList]);
  const isSelect = useCallback((tag) => {
    return value.indexOf(tag.key) > -1;
  }, [value]);
  const handleCheckAll = (checked) => {
    let tags = [];
    if (checked) {
      tags = ["all"];
    }
    return tags;
  };
  const handleCheckItem = (checked, tag) => {
    let tags = [];
    if (checked) {
      tags = [...value, tag.key].filter((item) => item !== "all");
    } else {
      tags = value.filter((item) => item !== (tag.key || "all"));
    }
    return tags;
  };
  const handleTagChange = (checked, tag) => {
    let newTags = [];
    const {key} = tag;
    if (key === "all") {
      newTags = handleCheckAll(checked);
    } else {
      newTags = handleCheckItem(checked, tag);
    }
    onChange && onChange(newTags);
  };
  const renderTag = (tag) => {
    const {key, text} = tag;
    if (key === "all") {
      return text;
    } else {
      return props?.renderTag ? props?.renderTag(text, tag) : text;
    }
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(styles.tagsPickerContainer, {[styles.isHidden]: showMore && moreVisible})
  }, /* @__PURE__ */ React.createElement("div", {
    className: styles.tagsContent,
    ref
  }, tagsData.map((tag) => {
    return /* @__PURE__ */ React.createElement(CheckableTag, {
      key: tag.key,
      checked: isSelect(tag),
      onChange: (checked) => {
        handleTagChange(checked, tag);
      }
    }, isSelect(tag) && /* @__PURE__ */ React.createElement("img", {
      src: check,
      style: {position: "absolute", right: "0", bottom: "0"}
    }), renderTag(tag));
  })), moreVisible && /* @__PURE__ */ React.createElement("div", {
    className: styles.moreTag
  }, /* @__PURE__ */ React.createElement("div", {
    onClick: () => {
      setShowMore(!showMore);
    }
  }, showMore ? /* @__PURE__ */ React.createElement(React.Fragment, null, formatMessage({id: "collapse"}), /* @__PURE__ */ React.createElement(UpOutlined, null)) : /* @__PURE__ */ React.createElement(React.Fragment, null, formatMessage({id: "more"}), /* @__PURE__ */ React.createElement(DownOutlined, null)))));
});
export default TagsPicker;
